import React from 'react';

import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';

import { AmountCurrencyFlag, AmountCurrencyLabel, AmountCurrencyText } from './styles';

const ConfirmAmountCurrency = (props) => {
    return (
        <AmountCurrencyLabel>
            <AmountCurrencyFlag>
                <FlagIcon name={props.currencyIcon} size="x-small" />
            </AmountCurrencyFlag>
            <AmountCurrencyText>{props.currencyCode}</AmountCurrencyText>
        </AmountCurrencyLabel>
    );
};

export default ConfirmAmountCurrency;
